import { ombtApi, MyReservationsEvents } from '@/infrastructure/Configuration'
import { EventReservation } from '../../domain/EventReservation'
import { getPageLanguage } from '@/infrastructure/Utils'

export default class EventsReservationsService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async getReservations({ status, page, limit }, transactionId) {
    const limitToDisplay = limit || MyReservationsEvents.LIMIT
    const url = `${ombtApi}/avail/v2/bookings?offset=${
      page !== undefined ? page : '0'
    }&limit=${limitToDisplay !== undefined ? limit : ''}&status=${status}`
    const config = {
      headers: {
        TransactionID: transactionId
      }
    }
    try {
      const { data } = await this.httpClient.get(url, config)
      const reservations = await Promise.all(
        data.bookingList.map(async reservation => {
          let hotel = await this.getHotelCardInfo(reservation.availDetails.hotelCode)
          hotel = await this.getHotelCheckOutInfo(hotel)

          return EventReservation.fromJSON({
            ...reservation,
            bookingStatus: status,
            hotel
          })
        })
      )
      return { reservations, total: data.total }
    } catch (error) {
      return {}
    }
  }

  async getBookingProcessUID() {
    const { data } = await this.httpClient.get(`${ombtApi}/avail/no-avail/uuid`)
    return data.bookingProcessUID
  }

  async getHotelCardInfo(backCode) {
    console.log('Entering getHotelCardInfo method')
    const hotelBackCode = backCode.toLowerCase()
    const { data } = await this.httpClient.get(`${ombtApi}/content/hotels/${hotelBackCode}`)

    return data
  }

  async getOmbtSummaryInfo(email, bookingFileId) {
    const config = {
      headers: {
        'Accept-Language': getPageLanguage(),
        'Content-Type': 'application/json'
      }
    }

    const { data, error } = await this.httpClient.post(
      '/ombt-api/avail/v2/booking',
      { bookingFileId, email },
      config
    )
    return { data, error }
  }

  async getHotelCheckOutInfo(hotelInfo) {
    console.log('Entering getHotelCheckOutInfo method!')
    if (hotelInfo == null) {
      console.log('hotelInfo is empty, returning')
      return hotelInfo
    }

    const hotelCheckOutInfo = await this.httpClient.get(
      `content/OMBTHotelFeatures/${this.hotelBackCode}`
    )

    if (
      hotelCheckOutInfo == null ||
      Object.keys(hotelCheckOutInfo).length === 0
    ) {
      return hotelInfo
    }

    return {
      ...hotelInfo,
      ...hotelCheckOutInfo
    }
  }
}
